module.exports = __webpack_public_path__ + "img/hr-level3addon_running_gun_shadow.7134e63d.png";